<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Localidad</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-text-field
	 	 		  name="search" solo v-model="table.search"
	 	 		  label="Buscar" append-icon="fa fa-search"
	 	 		  id="id"
	 	 		></v-text-field>
				<v-progress-linear :height="5" :active="table.loading" indeterminate></v-progress-linear>
	 	 	 	<v-data-table
	 	 	 	   :headers="table.headers"
	 	 	 	   :items="table.items"
	 	 	 	   :search="table.search"
	 	 	 	   class="elevation-1" v-model="selected"
	 	 	 	   show-select
	 	 	 	   pagination.sync="pagination"
	 	 	 	   item-key="id"
	 	 	 	 >
	 	 	 	   	<template v-slot:item.actions="props">
	 	 	 	   		<td>
	 	 	 	   			<v-btn text color="warning" small fab @click="edit(props.item)"><v-icon>fa fa-pen</v-icon></v-btn>
	 	 	 	   			<v-btn text color="error" small fab @click="confirmDelete(props.item)"><v-icon>fa fa-trash</v-icon></v-btn>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	 </v-data-table> 
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" @click="create()">Agregar nuevo Localidad</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 	<v-dialog
	 	  v-model="modalCreate.active"
	 	  scrollable persistent
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Crear nuevo Localidad</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	  <v-text-field
 	  	 	 	    name="name" required
 	  	 	 	    label="Nombre" solo
 	  	 	 	    v-model="modalCreate.data.name"
 	  	 	 	  ></v-text-field>
 	  	 	 	  <v-text-field
 	  	 	 	    name="name" required
 	  	 	 	    label="Coordenadas" solo
 	  	 	 	    v-model="modalCreate.data.coordinates"
 	  	 	 	  ></v-text-field>
 	  	 	 	  <v-select
							:items="selects.formats"
 	  	 	 	    name="name" required
 	  	 	 	    label="Formato" solo
 	  	 	 	    v-model="modalCreate.data.format"
 	  	 	 	  ></v-select>
 	  	 	 	  <v-text-field
							readonly
 	  	 	 	    name="name" required
 	  	 	 	    label="Proyección" solo
 	  	 	 	    v-model="modalCreate.data.projection"
 	  	 	 	  ></v-text-field>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalCreate.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="store()">Guardar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalEdit.active"
	 	  scrollable persistent
	 	  :overlay="false"
	 	  max-width="700px"
	 	  transition="dialog-transition"
	 	>
	 	  <v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Editar Localidad</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
 	  	 	 	  <v-text-field
 	  	 	 	    name="name" required
 	  	 	 	    label="Nombre" solo
 	  	 	 	    v-model="modalEdit.data.name"
 	  	 	 	  ></v-text-field>
 	  	 	 	  <v-text-field
 	  	 	 	    name="name" required
 	  	 	 	    label="Coordenadas" solo
 	  	 	 	    v-model="modalEdit.data.coordinates"
 	  	 	 	  ></v-text-field>
 	  	 	 	  <v-text-field
 	  	 	 	    name="name" required
 	  	 	 	    label="Formato" solo
 	  	 	 	    v-model="modalEdit.data.format"
 	  	 	 	  ></v-text-field>
 	  	 	 	  <v-text-field
 	  	 	 	    name="name" required
 	  	 	 	    label="Proyección" solo
 	  	 	 	    v-model="modalEdit.data.projection"
 	  	 	 	  ></v-text-field>	  	 	
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="update()">Guardar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalDelete.active"
	 	  scrollable  persistent
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Borrar Localidad</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	<p>¿ESTA SEGURO DE BORRAR ESTA LOCALIDAD?</p>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="deleteItem()">Confirmar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.messague }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
	export default{
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				createCategory: '',
				editCategory: '',
				baseRoute: process.env.VUE_APP_URL + 'api/gis/district',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				modalEdit: {
					active: false,
					data: {}
				},
				modalCreate: {
					active: false,
					data: {
						name: '',
						coordinates: '',
						format: '',
						projection: 'WGS84'
					}
				},
				modalDelete: {
					active: false,
					data: {}
				},
				alert: {
					active: false,
					messague: "",
					color: "success"
				},
				selects: {
					formats: [
						{text: 'WKT POLYGON', value: 'POLYGON'},
						{text: 'WKT POINT', value: 'POINT'},
						{text: 'DD (Lat, Lng)', value:'latlng'},
						{text: 'DMS (Grados/Minutos/Segundos)', value: 'd/m/s'},
					]
				},
				selected: []
			}
		},
		methods: {
			getData(){
				axios.get(this.baseRoute).then((res) => {
					this.table.loading = false;
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.messague = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
					}
				}).catch((error) => {
					this.table.loading = false;
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			create(){
				this.modalCreate.active = true;
				this.modalCreate.data = {name: '', projection: 'WGS84'};
			},
			store(){
				axios.post(this.baseRoute + '/store', this.modalCreate.data).then((res) => {
					if(res.data != "Exito"){
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Creado exitosamente";
						this.alert.color = "success";
						this.modalCreate.active = false;
						this.getData();
					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			edit(item){
				this.modalEdit.active = true;
				this.modalEdit.data = item;
			},
			update(){
				this.modalEdit.active = false;
				axios.put(this.baseRoute + '/update', this.modalEdit.data).then((res) => {
					if(res.data != "Exito"){
						this.modalEdit.data = {};
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Actualizado correctamente";
						this.alert.color = "success";					
						this.getData();

					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			confirmDelete(item){
				this.modalDelete.active = true;
				this.modalDelete.data = item;
			},
			deleteItem(){
				this.modalDelete.active = false;
				axios.post(this.baseRoute + '/destroy', this.modalDelete.data).then((res) => {
					if(res.data != "Exito"){
						this.modalDelete.data = {};
						this.alert.active = true;
						this.alert.messague = "Imposible de eliminar";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Eliminado correctamente";
						this.alert.color = "error";
						this.getData();
					}	
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
		},
		watch: {

		},
		computed: {

		},
	}
</script>